define('TescoMobile_Customer/js/loader',['jquery', 'TescoMobile_Customer/js/model/recaptcha-close', 'domReady!'], function ($, reCaptchaClose) {
  'use strict';

  return function () {
    $(".block-customer-login #login-form button.action.login").click(function () {
      const formValidationResult = $(".block-customer-login #login-form").valid();
      if (formValidationResult) {
        $(this).trigger('processStart');
        if (typeof window.grecaptcha !== "undefined") {
          reCaptchaClose.initCloseListener();
        }
      }
    });
  };
});

